<template>
  <div class="media guest">
    <div v-if="avatarShow" :class="{ 'pull-left': showInfo }">
      <a v-if="summaryShow" :href="summaryUrl" data-toggle="modal" data-target="#guest_informations">
        <img :src="guestBusinessUnit.avatar_url" title="info letto" class="js-tooltip guest-foto" :alt="guestBusinessUnit.full_name" />
      </a>
      <img
        v-else
        :src="guestBusinessUnit.avatar_url"
        title="info letto"
        class="js-tooltip guest-foto"
        :alt="guestBusinessUnit.full_name"
        data-placement="right"
      />
    </div>
    <div class="media-body" v-if="showInfo">
      <span :class="bDayShow ? 'wrap-data' : ''">
        <span v-if="fullNameShow" class="full_name text-uppercase" style="font-family: 'Asap-SemiBold'">{{
          guestBusinessUnit.full_name
        }}</span>
        <span v-if="bDayShow" class="bDay" style="font-family: 'Asap-Regular'">{{ formattedDate }}</span>
      </span>
      <div class="royalblue" id="status-info">
        <span v-if="unitShow" class="unit_description">{{ guestBusinessUnit.unit_description }}</span>
        <span v-if="roombadShow && guestBusinessUnit.room_bed_label" class="room_description">{{ guestBusinessUnit.room_bed_label }}</span>
        <span v-if="assSocAmmSostTutorShow && guestBusinessUnit.label_ass_soc_amm_sost_tutor" class="ass_description">
          {{ guestBusinessUnit.label_ass_soc_amm_sost_tutor }}
        </span>
        <span v-if="notes" class="notes_description">{{ notes }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const summaryDefaultUrl =
  'guest_period_data_sets/GUEST_PERIOD_DATA_SET__ID/summary?all_expanded=true&guest_period_data_set_id=GUEST_PERIOD_DATA_SET__ID&popup=true';
export default {
  name: 'guestMedia',
  props: [
    'notes',
    'guestBusinessUnit',
    'summaryShow',
    'avatarShow',
    'fullNameShow',
    'unitShow',
    'roombadShow',
    'assSocAmmSostTutorShow',
    'bDayShow',
  ],
  data() {
    return {
      summaryUrl: null,
      baseUrl: window.config.ePersonamService.ePersonamHost + '/' + window.locale + '/',
    };
  },
  computed: {
    showInfo() {
      return (
        this.fullNameShow ||
        this.unitShow ||
        (this.roombadShow && this.guestBusinessUnit.room_bed_label) ||
        (this.assSocAmmSostTutorShow && this.guestBusinessUnit.label_ass_soc_amm_sost_tutor) ||
        this.notes
      );
    },
    formattedDate() {
      return this.formatDate(this.dateString);
    },
  },
  watch: {
    guestBusinessUnit: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.guest_period_data_set_id) {
          this.summaryUrl = summaryDefaultUrl.replaceAll('GUEST_PERIOD_DATA_SET__ID', newVal.guest_period_data_set_id);
          this.summaryUrl = this.baseUrl + this.summaryUrl;
        }
      },
    },
  },
  methods: {
    formatDate() {
      // Verifica se la stringa è valida
      if (!this.guestBusinessUnit.birthdate) return '';

      // Split della stringa in anno, mese, giorno
      const [year, month, day] = this.guestBusinessUnit.birthdate.split('-');

      // Formatta la data in "giorno-mese-anno"
      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.roombed {
  width: 150px;
}

#status-info {
  font-size: 14px;
}
.guest-foto {
  border-radius: 100px !important;
}
.media-body {
  line-height: 22px;
}
.wrap-data {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.bDay {
  font-size: 13px;
  color: var(--adv-text-color);
}
</style>
